import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function RestorePositionToTop(props) {
    const location = useLocation();
    
    useEffect(() => {
        window.scroll({
            top: 0,
            behavior: 'smooth'
        });
    }, [location]);

    return <>{ props.children }</>
}
